import { ILookup } from '../../../../core';
import { AccountsListApiResponse, IAccount, ICreateAccountResponse } from '../dtos';

const accountScopes: ILookup<string>[] = [
  {
    englishName: 'vehicle scope',
    id: '1a71fe84-86d1-4433-acd8-fc1ae2d1bb59'
  },
  {
    englishName: 'New scope',
    id: '1a71fe84-86d1-4433-acd8-fc1ae2d1bb53'
  }
];

const createAccountResponse: ICreateAccountResponse = {
  createdOnUtc: '2025-02-18T20:11:49.6762263',
  modifiedOnUtc: '2025-02-18T20:11:49.6762398',
  createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  id: '7bd3e96d-0944-41d4-8e76-586a13542275',
  name: 'customer',
  phoneNumber: '011144455566',
  email: 'customer@gmail.com',
  logoId: '7bd3e96d-0944-41d4-8e76-586a13542275',
  address: {
    countryId: '7bd3e96d-0944-41d4-8e76-586a13542275',
    stateId: '7bd3e96d-0944-41d4-8e76-586a13542275',
    cityId: '7bd3e96d-0944-41d4-8e76-586a13542275',
    districtId: '7bd3e96d-0944-41d4-8e76-586a13542275',
    geographicalZoneId: '7bd3e96d-0944-41d4-8e76-586a13542275',
    addressLine1: 'street1',
    addressLine2: 'street2',
    location: {
      latitude: 55,
      longitude: 44
    }
  }
};

const accountsResponse: AccountsListApiResponse = {
  items: [
    {
      createdOnUtc: '2025-02-18T20:11:49.6762263',
      modifiedOnUtc: '2025-02-18T20:11:49.6762398',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'customer',
      phoneNumber: {
        countryCode: '+20',
        number: '11144455566'
      },
      logo: {
        id: '7bd3e96d-0944-41d4-8e76-586a13542275',
        name: 'Test',
        size: 5847
      },
      email: 'customer@gmail.com',
      address: {
        country: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Egypt'
        },
        state: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Cairo'
        },
        city: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Maddi',
          arabicName: 'Maddi'
        },
        district: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Hai elmaadi'
        },
        geographicalZone: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'upper'
        },
        addressLine1: 'street1',
        addressLine2: 'street2',
        location: {
          latitude: 55,
          longitude: 44
        }
      },
      adminAccount: {
        id: '7bd3e96d-0944-41d4-8e76-586a13542275',
        firstName: 'first name',
        lastName: 'last name',
        email: 'name@name.com'
      }
    },
    {
      createdOnUtc: '2025-02-18T20:11:49.6762263',
      modifiedOnUtc: '2025-02-18T20:11:49.6762398',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'customer',
      phoneNumber: {
        countryCode: '+20',
        number: '11144455566'
      },
      logo: {
        id: '7bd3e96d-0944-41d4-8e76-586a13542275',
        name: 'Test',
        size: 5847
      },
      email: 'customer@gmail.com',
      address: {
        country: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Egypt'
        },
        state: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Cairo'
        },
        city: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Maddi',
          arabicName: 'Maddi'
        },
        district: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'Hai elmaadi'
        },
        geographicalZone: {
          id: '7bd3e96d-0944-41d4-8e76-586a13542275',
          englishName: 'upper'
        },
        addressLine1: 'street1',
        addressLine2: 'street2',
        location: {
          latitude: 55,
          longitude: 44
        }
      },
      adminAccount: {
        id: '7bd3e96d-0944-41d4-8e76-586a13542275',
        firstName: 'first name',
        lastName: 'last name',
        email: 'name@name.com'
      }
    }
  ],
  paginationMetadata: {
    totalItemCount: 11706,
    numberOfPages: 1171,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: true,
    hasPrevious: false
  }
};
const accountResponse: IAccount = {
  createdOnUtc: '2025-02-18T20:11:49.6762263',
  modifiedOnUtc: '2025-02-18T20:11:49.6762398',
  createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  id: '7bd3e96d-0944-41d4-8e76-586a13542275',
  englishName: 'customer',
  phoneNumber: {
    countryCode: '+20',
    number: '11144455566'
  },
  logo: {
    id: '7bd3e96d-0944-41d4-8e76-586a13542275',
    name: 'Test',
    size: 5847
  },
  email: 'customer@gmail.com',
  address: {
    country: {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'Egypt'
    },
    state: {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'Cairo'
    },
    city: {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'Maddi',
      arabicName: 'Maddi'
    },
    district: {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'Hai elmaadi'
    },
    geographicalZone: {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'upper'
    }
  },
  adminAccount: {
    id: '7bd3e96d-0944-41d4-8e76-586a13542275',
    firstName: 'first name',
    lastName: 'last name',
    email: 'name@name.com'
  }
};

export const accountsData = {
  accountScopes,
  accountResponse,
  createAccountResponse,
  accountsResponse
};
